import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { ParFormFieldComponent } from '@shared/ui';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-textarea-control',
  templateUrl: 'textarea-control.component.html',
  styleUrls: ['textarea-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormTextareaControlComponent,
    },
  ],
})
export class DynamicFormTextareaControlComponent extends AbstractDynamicFormControl {}
